import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function PasswordReset() {
  const [pars] = useSearchParams();
  const [success, setSuccess] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const [errors, setErrors] = useState([]);
  const address = "https://authserverreceipt.azurewebsites.net//api/Authentication/passwordreset";
  async function handleSubmit(e) {
    e.preventDefault();
    let error = false;
    let curErrors = [];
    const token = pars.get("token");
    const email = pars.get("email");
    if (password.length < 6) {
      curErrors["password"] = "Дължината трябва да е поне 3 символа";
      error = true;
    }
    if (password !== passwordRepeat) {
      curErrors["passwordconfirm"] = "Паролите не съвпадат";
      error = true;
    }
    if (!token || !email) {
      curErrors["common"] = "Грешен адрес. Отворете линка отново";
      error = true;
    }
    setErrors(curErrors);
    if (error) {
      return;
    }
    // POST request using fetch with async/await
    const req = { Email: email, Token: token, Password: password };
    const body = JSON.stringify(req);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
    };
    let respErrors = [];
    const response = await fetch(address, requestOptions);
    if (response.status === 200) {
      setSuccess(true);
      return;
    }
    setSuccess(false);
    const data = await response.json();
    respErrors["common"] = data.Errors ? data.Errors[0] : "Непредвидена грешка";
    setErrors(respErrors);
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-md-center">
        {success && (
          <div class="alert alert-success mt-3" v-if="success">
            Паролата беше сменена успешно
          </div>
        )}
        <form className="col-md-6" onSubmit={ handleSubmit}>
          <div className="mb-3">
            <label for="exampleInputPassword1" className="form-label">
              Парола
            </label>
            <div className="input-group has-validation">
              <input type="password" onChange={(e) => setPassword(e.target.value)} className={"form-control " + (errors["password"] && "is-invalid")} />
              <div className="invalid-feedback">{errors["password"]}</div>
            </div>
          </div>
          <div className="mb-3">
            <label for="exampleInputPassword1" class="form-label">
              Повторете паролата
            </label>
            <div className="input-group has-validation">
              <input type="password" onChange={(e) => setPasswordRepeat(e.target.value)} className={"form-control " + (errors["passwordconfirm"] && "is-invalid")} />
              <div className="invalid-feedback">{errors["passwordconfirm"]}</div>
            </div>
          </div>
          <div className="row">
            <label className="h5 text-danger">{errors["common"]}</label>
          </div>
          <div className="row g-1">
            <button type="submit" className="btn btn-primary col-3">
              Смени
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
